export const useCookiesStore = defineStore('cookie.store', () => {
  const { enable: enableDebug } = storeToRefs(useDebugStore())

  const isCookieMessageHidden = ref<boolean>(true)
  const cookiesDomain = computed(() => {
    const isDev = process.env.NODE_ENV === 'development'

    if (isDev) return ''

    return enableDebug.value ? '.kassirdev.ru' : '.kassir.ru'
  })

  const setCookieMessageInvisibility = (toggler: boolean) => {
    localStorage.setItem('isCookieMessageHidden', toggler.toString())

    isCookieMessageHidden.value = toggler
  }

  return {
    isCookieMessageHidden,
    cookiesDomain,
    setCookieMessageInvisibility,
  }
})
